import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function ProtectedRoute({ children, requireOnboarding = true }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen grid place-items-center bg-cream">
                <div className="w-16 h-16 rounded-full bg-sage/40 animate-breathe-slow" />
            </div>
        );
    }
    if (!user) return <Navigate to="/auth" state={{ from: location }} replace />;
    if (requireOnboarding && !user.onboarded) return <Navigate to="/onboarding" replace />;
    return children;
}
